module.exports = __webpack_public_path__ + "img/student-unlight.49723157.png";